import React, { Component } from "react";
import Modal from "../common/Modal";
import { IMAGE_URI } from "../../utils/config";
import isEmpty from "../../validation/is-empty";

export class ViewProfile extends Component {
  handleCancelViewProfile = () => {
    this.props.handleCancelViewProfile();
  };
  render() {
    const { user } = this.props;
    return (
      <Modal
        id="viewProfile"
        key="viewProfile"
        open={true}
        size={"medium"}
        header="View Profile"
        onClose={this.handleCancelViewProfile}
      >
        <div className="row">
          <div className="col-md-12">
            <div
              className="profile-image"
              style={{ textAlign: "center", marginBottom: "10px" }}
            >
              {isEmpty(user.attachment) ? (
                <img
                  className="pro-img"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%"
                  }}
                  src={require("../../assets/img/profile.png")}
                  alt={user.name}
                />
              ) : (
                <img
                  className="pro-img"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%"
                  }}
                  src={`${IMAGE_URI}/${user.attachment.dir}/${user.attachment.filename}`}
                  alt={user.name}
                />
              )}
            </div>
          </div>
          <div className="col-md-offset-3 col-md-6 col-md-offset-3">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Name</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Name"
                readOnly
                value={user.name}
              />
            </div>
          </div>
          <div className="col-md-offset-3 col-md-6 col-md-offset-3">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Email</label>
              <input
                type="text"
                className="form-control"
                id="email"
                name="email"
                placeholder="Email"
                readOnly
                value={user.email}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ViewProfile;



// WEBPACK FOOTER //
// ./src/components/Header/ViewProfile.js